import React from 'react'

export default function Cultivating() {
    return (
        <div className="container mx-auto px-4 py-10 flex flex-col-reverse md:flex-row items-center gap-8">
            {/* — Text half — */}
            <div className="w-full md:w-1/2">
                <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-black text-left">
                    Phygital Model for Maximum Reach
                </h1>
                <h2 className="text-xl sm:text-2xl text-blue-500 font-bold mt-2 text-left">
                    KrishiYan functions on a Phygital Model
                </h2>
                <p className="mt-4 text-base sm:text-lg text-[#616161] text-left">
                    Combining digital cloud services with local, on-ground support from FPO hubs. Farmers access KrishiYan’s digital platform remotely for advisory and market services, while local FPO centers provide hands-on assistance, ensuring comprehensive support at every step of the farming process.
                </p>
                <ul className="mt-4 list-disc pl-5 space-y-2 text-base sm:text-lg text-black text-left">
                    <li>Capacity Building and Infrastructure Support</li>
                    <li>Quality Control and Market Competitiveness</li>
                    <li>Continuous Training and Knowledge Sharing</li>
                </ul>
            </div>

            {/* — Image half — */}
            <div className="w-full md:w-1/2 flex justify-center">
                <img
                    src="/Images/Cultivating.png"
                    alt="Cultivating"
                    className="w-full max-w-sm md:max-w-md lg:max-w-lg h-auto rounded-lg shadow-md"
                />
            </div>
        </div>
    )
}
